/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteFragment} from 'relay-runtime';
export type WidgetTypeRouter_widget = {|
  +id: string;
  +type: ?string;
|};
*/


const fragment /*: ConcreteFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "WidgetTypeRouter_widget",
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "args": null,
      "name": "id",
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "args": null,
      "name": "type",
      "storageKey": null
    },
    {
      "kind": "FragmentSpread",
      "name": "withWidgetData_widget",
      "args": null
    }
  ],
  "type": "Widget"
};

module.exports = fragment;



// WEBPACK FOOTER //
// ./src/components/WidgetTypeRouter/__generated__/WidgetTypeRouter_widget.graphql.js